import React, { useEffect } from 'react';
import { Pagination } from 'react-bootstrap';

function CommonPagination({ pageCnt, selectedPage, SetSelectedPage, GetNewTableData }) {
	// const [selectedPage, setSelectedPage] = useState(1);

	function onClickPageItem(e) {
		if (e.target.text) {
			const newSelectedPage = parseInt(e.target.text, 10);
			SetSelectedPage(newSelectedPage);
			GetNewTableData(newSelectedPage);
		}
	}

	function onClickArrowItem(newSelectedPage) {
		if (newSelectedPage > 0 && newSelectedPage <= pageCnt) {
			SetSelectedPage(newSelectedPage);
			GetNewTableData(newSelectedPage);
		}
	}

	useEffect(() => {
		SetSelectedPage(1);
	}, [pageCnt]);

	const items = [];

	for (let number = 1; number <= pageCnt; number += 1) {
		items.push(
			<Pagination.Item
				key={number}
				linkClassName="paginationItem"
				active={number === selectedPage}
				onClick={e => onClickPageItem(e)}
			>
				{number}
			</Pagination.Item>,
		);
	}

	return (
		<Pagination className="pagination" style={{ marginTop: '1.25rem' }}>
			<Pagination.Prev
				linkClassName="paginationItem icon"
				onClick={() => onClickArrowItem(selectedPage - 1)}
			>
				Previous
			</Pagination.Prev>
			{items}
			<Pagination.Next
				linkClassName="paginationItem icon"
				onClick={() => onClickArrowItem(selectedPage + 1)}
			>
				Next
			</Pagination.Next>
		</Pagination>
	);
}

export default CommonPagination;
